<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Validation des Ventes</h1>
    </div>

    <div class="card">
      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :filterableFields="filterableFields"
            :row-actions="rowActions"
            :items="sales"
            @validate="onValidate"
            @reject="onReject"
            @history="onHistory"
            @details="goToDetails"
            @print="printInvoice"
        >
          <template #cell-reference="{ item }">
            <span class="text-primary fw-bold">{{ item.reference }}</span>
          </template>
          <template #cell-totalAmount="{ item }">
            {{ item.totalAmount | currency }}
          </template>
          <template #cell-sellerName="{ item }">
            <span class="text-muted">{{ item.sellerName }}</span>
          </template>
          <template #cell-saleDate="{ item }">
            {{ item.saleDate | dateFormat('DD/MM/YYYY HH:mm') }}
          </template>
          <template #cell-status="{ item }">
            <span class="badge"
                  :class="{
                'bg-success': item.status === 'VALIDATED',
                'bg-warning': item.status === 'PENDING',
                'bg-danger': item.status === 'REJECTED'
              }">
              {{ item.status }}
            </span>
          </template>
        </TableWithFilters>
      </div>
    </div>
  </div>
</template>

<script>

  import {adminSaleColumns, adminSaleFilterableFields, adminSaleRowActions} from "../../../helpers/constants";
  import TableWithFilters from "../../../components/TableWithFilters.vue";
  import {showValidationErrors} from "../../../helpers/helpers";
  import {printInvoice, printInvoicePDF} from "../../../helpers/exporter";

  export default {
    name: "AdminSales",
    components: {TableWithFilters},
    data() {
      return {
        sales: [],
        columns: adminSaleColumns,
        filterableFields: adminSaleFilterableFields,
        rowActions: adminSaleRowActions
      };
    },
    methods: {
      printInvoice(sale) {
        console.log("🧾 Vente à imprimer :", sale);

        const saleLines = sale.saleLines || [];

        printInvoicePDF(sale, saleLines); // appelle la fonction d'export réelle
      },
      goToDetails(item) {
        this.$router.push({ name: 'adminSaleDetails', params: { id: item.id } });
      },
      loadSales() {
        this.$loading(true);
        this.$http.get(`/sales`) // ou `/sales?status=PENDING` si filtré
            .then(({ data }) => {
              this.sales = data;
            })
            .catch(err => console.error("Erreur chargement ventes admin :", err))
            .finally(() => this.$loading(false));
      },

      onValidate(item) {
        swal({
          title: 'Valider la vente',
          text: `Confirmez-vous la validation de la vente #${item.reference} ?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Oui, valider',
          cancelButtonText: 'Annuler'
        }).then(result => {
          if (result.isConfirmed) {
            this.$loading(true);
            this.$http.put(`/sales/${item.id}/validate`)
                .then(() => {
                  swal('Validée', 'La vente a été validée.', 'success');
                  this.loadSales();
                })
                .catch(showValidationErrors)
                .finally(() => this.$loading(false));
          }
        });
      },

      onReject(item) {
        swal({
          title: 'Rejeter la vente',
          input: 'text',
          inputLabel: 'Motif du rejet',
          inputPlaceholder: 'Ex : produit non disponible',
          showCancelButton: true,
          confirmButtonText: 'Rejeter',
          cancelButtonText: 'Annuler'
        }).then(result => {
          if (result.isConfirmed) {
            this.$loading(true);
            this.$http.put(`/sales/${item.id}/reject`, {
              comment: result.value
            }).then(() => {
              swal('Rejetée', 'La vente a été rejetée.', 'success');
              this.loadSales();
            }).catch(showValidationErrors)
                .finally(() => this.$loading(false));
          }
        });
      },

      onHistory(item) {
        this.$http.get(`/sales/${item.id}/history`)
            .then(({ data }) => {
              const html = data.map(h => `
        <li><strong>${h.status}</strong> à ${this.$options.filters.dateFormat(h.timestamp, 'DD/MM/YYYY HH:mm')}</li>
      `).join('');
              swal({
                title: `Historique de la vente #${item.reference}`,
                html: `<ul style="text-align:left">${html}</ul>`,
                confirmButtonText: 'Fermer'
              });
            });
      }
    },
    mounted() {
      this.loadSales();
    }
  };
</script>
